var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"col":"12","lg":"12"}},[_c('CCard',[_c('CCardBody',[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('terms.title'))+" ")]),_c('br'),_c('CRow',[_c('CCol',{attrs:{"col":"12","lg":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.configuration)}})])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }